<nav class="nav nav-pills">
  <a
    class="nav-item nav-link"
    routerLink="/capture-admin/patients/{{patient.id}}"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">
    Patient Details
  </a>
  <a
    class="nav-item nav-link"
    routerLink="/capture-admin/patients/{{patient.id}}/captures"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">
    Captures
  </a>
  <a
    class="nav-item nav-link"
    routerLink="/capture-admin/patients/{{patient.id}}/referrals"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">
    Referrals
  </a>
  <a
    class="nav-item nav-link"
    routerLink="/capture-admin/patients/{{patient.id}}/communications"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">
    Communications
  </a>
  <a
    class="nav-item nav-link"
    routerLink="/capture-admin/patients/{{patient.id}}/encounters"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">
    Encounters
  </a>
  <a
    class="nav-item nav-link"
    routerLink="/capture-admin/patients/{{patient.id}}/prescriptions"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">
    Prescriptions
  </a>
  <a
    class="nav-item nav-link"
    routerLink="/capture-admin/patients/{{patient.id}}/documents"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">
    Documents
  </a>
</nav>
